import { View } from 'foundations-components/components/View';
import { PriorityRender } from '../../loadable/lib/PriorityRender';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolbarPlaceholder = () => {
  return /*#__PURE__*/_jsx(View, {
    blockSize: "100%",
    backgroundColor: "fill-field-default"
  });
};
const loadToolbar = () => import( /* webpackChunkName: "toolbar" */'./Toolbar');
const AsyncRenderToolbar = () => {
  return /*#__PURE__*/_jsx(PriorityRender, {
    priority: "low",
    LoadingComponent: ToolbarPlaceholder,
    loader: loadToolbar,
    LOGGING_COMPONENT_NAME: "AsyncRenderToolbar"
  });
};
export default AsyncRenderToolbar;